import React, { useState } from "react";

import CovertButton from "@cayuse/shared-react.components.covert-button";
import Icon from "@cayuse/shared-react.components.icon";
import { AlertDialog } from "@cayuse/shared-react.components.modal-dialog";

import useDictionary from "hooks/useDictionary";

import styles from "../styles.css";
import DataTableColumn from "./DataTableColumn";

const DataTableRow = ({ row, rowIndex, columns, removeRow, ...props }) => {
	const dictionary = useDictionary("dataTable") || {};
	const [ showModal, setShowModal ] = useState(false);
	const { extraSettings: {
		columns: originalColumns = [],
	} } = props.config.$original || {};

	const remove = () => {
		setShowModal(false);
		removeRow(rowIndex);
	};

	return (
		<tr className={styles.dataTableRow}>
			{columns.map((column, index) => (
				<td className={`${styles.dataTableColumn} ${styles[column.id]}`}>
					<DataTableColumn
						key={column.id}
						column={column}
						originalColumn={originalColumns[index]}
						row={row}
						rowIndex={rowIndex}
						{...props}
					/>
				</td>
			))}
			<td className={`${styles.dataTableColumn}`}>
				{!!rowIndex && props.config?.enabled && <CovertButton
					onClick={() => setShowModal(true)}
					aria-label={dictionary.removeRowButton ?? "Remove Row"}
				                                        >
					<Icon
						className={styles.blue}
						name="trash"
						size="bigger"
					/>
				</CovertButton>}
				{showModal &&
				<AlertDialog
					title={dictionary.removeRowTitle ?? "Remove row?"}
					description={dictionary.removeRowDescription ?? "Are you sure you want to remove this row?"
					}
					isOpen={showModal}
					onConfirm={remove}
					confirmText={dictionary.removeRowButton || "Remove Row"}
					onCancel={() => setShowModal(false)}
				/>
				}
			</td>
		</tr>
	);
};

export default DataTableRow;
